<template>
    <div class="">
        <van-nav-bar left-arrow left-text="Kembali" @click-left="$router.push('/waiting-room')">

            <template #title>
                <a href="/">
                    <div style="display: flex;">
                        <img src="/image/jkn.png" style="max-height: 40px;" alt="">
                        <div style="font-weight: bold;font-size:1.9em;color:black;"></div>
                    </div>
                </a>
            </template>
        </van-nav-bar>
        <div style="" class="wrapper">
            <div class="video" style="position: sticky; z-index : 1; top : 0;  max-width: 100%;background : white;">
                <div v-if="videoStarted">
                    <div  :style="`height : ${Math.floor(screenHeight/4)}px`"
                        style="width : 100%;position : absolute;z-index : 100;"></div>
                    <div id="player" data-plyr-provider="youtube"  :data-plyr-embed-id="event.youtube_url">
                    </div>
                </div>

                <div v-else :style="`height : ${screenHeight}px`"
                    style="text-align: center;background:black;color:white;display:flex;justify-content:center;align-items:center;">
                    <div>
                        LIVE pada {{getDateTime()}}
                        <van-count-down style="color:orange;margin-top : 10px;" :time="time">

                            <template v-slot="timeData">
                                <span class="block">{{ timeData.days }} h</span>
                                <span class="colon">:</span>
                                <span class="block">{{ timeData.hours }} j</span>
                                <span class="colon">:</span>
                                <span class="block">{{ timeData.minutes }} mnt</span>
                                <span class="colon">:</span>
                                <span class="block">{{ timeData.seconds }} dtk</span>
                            </template>

                        </van-count-down>
                    </div>

                </div>
                <van-cell>
                    <div style="font-weight: bold;font-size : 1.3em;">{{event.title}}</div>
                    <DIV class="text-muted"><span>{{pemirsa}} telah menonton</span>
                
                    </DIV>
                     <van-divider v-if="videoStarted && is_focus == false"></van-divider>
                    <div v-if="videoStarted && is_focus == false" >
                       
                          <a href="https://mega.nz/file/gnwSiKaJ#8zeVE62SVdj0VH3YEvBG2tGYkWu_nLjFIhSdwdvFglw" style="    color: #fff;
    background-color: #07c160;
    border: 1px solid #07c160; margin-right : 10px; padding : 4px 10px;" target="_blank" download="video.jkt">DOWNLOAD 1080p</a>
     <a href="https://mega.nz/file/wyoGRCSQ#KjmtDBr3AwQ3gm01G1Y0ujTbv39ziB6aMmQSBCCUmaM" style="    color: #fff;
    background-color: #07c160;
    border: 1px solid #07c160; margin-right : 10px; padding : 4px 10px;" target="_blank" download="video.jkt">720p</a>
                           <a href="/sub-id.srt" style="    color: #fff;
    background-color: #07c160;
    border: 1px solid #07c160; margin-right : 10px; padding : 4px 10px;"  download>SUBTITLE : ID</a>
                    </div>

                </van-cell>

            </div>
            <div class="content" style="background : white;">
                <div>
                    <van-notice-bar  v-if="videoStarted && is_focus == false" text="REFRESH BROWSER jika video tidak bisa diputar"
                        left-icon="volume-o" />

                    <div id="chat" :style="`max-height:${contentHeight}px`" style="overflow-y: auto;">
                        <van-cell :key="message.id" v-for="message in messages">
                            <div>

                                <span style="margin-right : 5px;" :style="`color:${message.color}`">{{message.nama}}
                                    :</span>
                                {{message.text}}

                            </div>
                            <div v-if="message.sound_path">
                                <audio style="max-width: 100%;" controls preload="none">
                                    <source :src="message.sound_path" type="audio/wav">
                                </audio>
                            </div>
                        </van-cell>
                    </div>
                    <div v-if="unread_chat > 0" @click="scrollToDown()" :style="`width : ${contentWidth}px`"
                        style="position: fixed; bottom : 90px;text-align : center;max-width: 100%;">
                        <van-button type="primary" icon="down" size="mini">{{unread_chat}} chat masuk</van-button>
                    </div>
                    <div style="position: fixed;   max-width: 100%;" class="form-chat"
                        :style="`width : ${chatFormWidth}px;`">

                        <van-field @focus="is_focus = true" @blur="is_focus = false" v-model="message" @keyup.enter="sendByKeyboard" autosize row="1" type="textarea"
                            center clearable :placeholder="recordState ? 'Sedang Merekam...' : 'Tulis Pesan'">
                            <template #button>
                                <van-button v-if="cooldown > 0" :disabled="cooldown > 0" size="small" type="primary">
                                    {{cooldown}}</van-button>
                                <van-button v-if="cooldown <= 0 " :disabled="cooldown > 0" @click="sendMessage()"
                                    size="small" type="primary">
                                    Kirim</van-button>
                                <!-- <button class="van-button  van-button--small" :class="recordState ? 'van-button--warning' : 'van-button--primary'" v-if="cooldown <= 0 && message.length == 0"  @mousedown="record()" @mouseup="stopRecord()">KIRIM</button> -->
                            </template>
                        </van-field>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'
    import axios from 'axios'
    /*eslint-disable */
    // Your web app's Firebase configuration
    var firebaseConfig = {
        apiKey: "AIzaSyAHO9QZ8kQBlE-XS6PHiIvDdqQ-BCQ7X3w",
        authDomain: "jkdn-3731d.firebaseapp.com",
        databaseURL: "https://jkdn-3731d.firebaseio.com",
        projectId: "jkdn-3731d",
        storageBucket: "jkdn-3731d.appspot.com",
        messagingSenderId: "935470040521",
        appId: "1:935470040521:web:f3b981bf8b7b06035a1418"
    };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    // Initialize Firebase

    /*eslint-enable */
    export default {
        data: () => ({
            cooldown: 0,
            download_data : '',
            active: '1',
            is_focus : false,
            videoStarted: false,
            player: {},
            jumlah_audience: 1000,
            id_zone: 'WIB',
            time: 0,
            mulaiDalam: 100,
            peserta: {},

            event: {
                title: 'FILM JEJAK KHILAFAH DI NUSANTARA',
                nama_penyelenggara: 'JKDN Movie',
                waktu: new Date('2020-08-23 02:00:00'),
                images: [],
                youtube_url: '',
                tanya_usia: false,
                jumlah_peserta: 100
            },
            screenHeight: 0,
            screenWidth: 0,
            contentWidth: 768,
            contentHeight: 100,
            native: false,
            videoWidth: 768,
            pemirsa : 1,
            chatFormWidth: 768,
            messages: [],
            recordState: false,
            message: '',
            roomId: '',
            recordStart: new Date(),
            user: {},
            text: '',
            data_peserta: {
                current: 1
            },
            chatRef: {},
            unread_chat: 0,
            mediaRecorder: {},

        }),
        mounted() {
        
            this.initSize();

                    axios.get(this.$parent.endpoint + '/pemirsa').then(response => {
                                this.pemirsa = response.data;
                               
                            })

            if (this.event) {
                this.syncCooldown();
                var offset = new Date().getTimezoneOffset() / 60;
                if (offset == -8) {
                    this.id_zone = 'WITA';
                }
                if (offset == -9) {
                    this.id_zone = 'WIT';
                }
                this.event.waktu = moment(this.event.waktu).subtract(offset, 'hours').toDate();
                this.time = (this.event.waktu.getTime() - new Date().getTime());
                if (this.time > 0) {
                    var interval = setInterval(() => {
                        var innerTime = (this.event.waktu.getTime() - new Date().getTime());
                        if (innerTime < 0) {
                            clearInterval(interval);
                            axios.get(this.$parent.endpoint + '/random-video').then(response => {
                                this.event.youtube_url = response.data;
                                this.initYoutube();
                            })

                        }
                    }, 1000)
                } else {
                    axios.get(this.$parent.endpoint + '/random-video').then(response => {
                        this.event.youtube_url = response.data;
                        this.initYoutube();
                    })
                }

                this.roomId = this.event.id + '-' + this.event.slug;


                var peserta = localStorage.getItem('peserta');
                if (peserta) {
                    this.peserta = JSON.parse(peserta)
                    /*eslint-disable */
                    var connected = firebase.database().ref(this.$route.path + '/connected');
                    var chatRef = firebase.database().ref(this.$route.path + '/chat').limitToLast(100);

                    chatRef.on('value', (snapshot) => {
                        if (snapshot.val()) {
                            this.messages = snapshot.val();







                            setTimeout(() => {

                                if ((document.getElementById("chat").scrollTop + document
                                        .getElementById(
                                            "chat").clientHeight) >= (document.getElementById("chat")
                                        .scrollHeight - (44))) {

                                    this.scrollToDown()

                                } else {

                                    this.unread_chat++;
                                };

                            }, 500)

                        }
                    })

                } else {
                    this.$router.push('/')
                }
            }

            document.querySelector('#chat').addEventListener("scroll", () => {

                if ((document.getElementById("chat").scrollTop + document.getElementById("chat")
                        .clientHeight) >= (document.getElementById("chat").scrollHeight)) {

                    this.unread_chat = 0;

                }
            });

            window.addEventListener('resize', () => {
                // do stuff here

                this.initSize();

            });

            setInterval(() => {
                this.cooldown--;
            }, 1000)





        },
        methods: {
            substractPeserta() {
                var data = this.data_peserta;
                data.current = data.current - 1;
                return data;
            },
            typeNow(event) {
                this.text = event;
            },
            downloadVideo()
            {
                axios.post(this.$parent.endpoint+"/youtube?videoId="+this.youtube_parser(this.event.youtube_url)).then(response=>{
                    this.download_data = response.data;
                })
            },


            banPeserta() {
                // axios.put('/home/peserta/'+peserta_id,{ban_type : value}).then(response=>{
                //     // socket.emit('banned-by-admin', {
                //     //     room: this.roomId,
                //     //     peserta : response.data
                //     // });
                // })
            },
            syncCooldown() {
                if (this.peserta.id) {
                    var offset = new Date().getTimezoneOffset() / 60;
                    var until = moment(this.peserta.banned_until).subtract(offset, 'hours').toDate();

                    if (moment().isBefore(until)) {
                        this.cooldown = Math.floor((until.getTime() - new Date().getTime()) / 1000);
                    }
                }

            },
            initSize() {
                if (innerWidth <= 768) {

                    this.screenWidth = innerWidth;
                    this.screenHeight = Math.floor(this.screenWidth / 16 * 9);
                    this.contentWidth = this.screenWidth;
                    this.contentHeight = innerHeight - this.screenHeight - 182;
                    this.chatFormWidth = this.contentWidth;
                } else {
                    this.screenWidth = Math.floor(innerWidth / 100 * 75);
                    this.screenHeight = Math.floor(this.screenWidth / 16 * 9);
                    this.contentWidth = Math.floor(innerWidth / 100 * 25);
                    this.contentHeight = innerHeight - 130;
                    this.chatFormWidth = this.contentWidth - 26;
                }
            },
            scrollToDown() {
                document.getElementById("chat").scrollTop = document.getElementById("chat").scrollHeight
                this.unread_chat = 0;
            },

            /*eslint-disable */
            initYoutube() {
                if (this.event.youtube_url) {
                    this.videoStarted = true;

                     setTimeout(() => {
                            const player = new Plyr('#player', {
                                autoplay : true,
                                youtube : {cc_lang_pref : 'id', cc_load_policy : 1, rel : 0, loop : 1}});
                            this.contentHeight = this.contentHeight - 40;


                        }, 1000)

                    // if (innerWidth <= 768) {
                    //     var tag = document.createElement('script');
                    //     this.native = true;

                    //     tag.src = "https://www.youtube.com/iframe_api";
                    //     var firstScriptTag = document.getElementsByTagName('script')[0];
                    //     firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                    //     if (typeof onYouTubeIframeAPIReady == 'undefined') {
                    //         window.onYouTubeIframeAPIReady = () => {
                    //             this.loadPlayer();
                    //             this.contentHeight = this.contentHeight - 50;
                    //         }
                    //         console.log('undefined')
                    //     }else{
                    //          this.loadPlayer();
                    //             this.contentHeight = this.contentHeight - 50;
                    //     }
                    // } else {
                       


                    // }


                } else {

                }

            },
            youtube_parser(url) {
                var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                var match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            },
            loadPlayer() {
                this.player = new YT.Player('player', {
                    height: this.screenHeight,
                    width: this.screenWidth,
                    videoId: this.youtube_parser(this.event.youtube_url),
                    events: {
                        'onReady': (event) => {
                            console.log(this.event.youtube_url)
                            var iframe = document.querySelector('#player');
                            var requestFullScreen = iframe.requestFullScreen || iframe
                                .mozRequestFullScreen || iframe
                                .webkitRequestFullScreen;


                        },
                        'onStateChange': (event) => {


                        }
                    }
                });


            },
            /*eslint-enable */
            sendByKeyboard(event) {
                if (!event.shiftKey) {
                    this.sendMessage();
                }
            },
            sendMessage() {
                if (this.cooldown <= 0 && this.message) {
                    /*eslint-disable */
                    firebase.database().ref(this.$route.path + '/chat').push({
                        nama: this.peserta.nama,
                        text: this.message,
                        peserta_id: this.peserta.id,
                        timestamp: Date.now()
                    })

                    /*eslint-enable */

                    this.message = '';
                    this.cooldown = 5;
                    this.scrollToDown();
                }



            },
            timeStringify() {
                return moment(this.event.waktu).format('D MMM YYYY');
            },
            dataTime() {
                var offset = new Date().getTimezoneOffset() / 60;
                return moment(moment(this.event.waktu).format('YYYY-MM-DD') + ' ' + this.time).add(offset,
                    'hours').format('YYYY-MM-DD HH:mm');
            },
            getTime() {
                return moment(this.event.waktu).format('HH:mm');
            },
            getDateTime() {

                return this.timeStringify() + ' ' + this.getTime() + ' ' + this.id_zone;

            }
        },
    }
</script>
<style>
    @media only screen and (max-width: 768px) {
        .video {
            width: 100%;
        }

        .form-chat {
            margin-left: 0px;
            border-top: 1px solid #eff0f1;
            bottom: 0px;
        }
    }

    @media only screen and (min-width: 769px) {
        .video {
            width: 75%;
        }

        .content {
            width: 25%;
            ;
            max-width: 100%;
            ;
        }

        .wrapper {
            display: flex;
            ;
        }

        .form-chat {
            margin-left: 10px;
            border: 3px solid #eff0f1;
            bottom: 10px;
        }
    }

    body {
        background: white;
    }

    [v-cloak]>* {
        display: none
    }

    [v-cloak]::before {
        content: "loading…"
    }



    pre {
        white-space: pre-wrap;
        /* Since CSS 2.1 */
        white-space: -moz-pre-wrap;
        /* Mozilla, since 1999 */
        white-space: -pre-wrap;
        /* Opera 4-6 */
        white-space: -o-pre-wrap;
        /* Opera 7 */
        word-wrap: break-word;
        /* Internet Explorer 5.5+ */
        font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
    }
</style>